import classnames from 'classnames'
import React from 'react'
import Radio from '@mui/material/Radio'
import FormControlLabel from '@mui/material/FormControlLabel'
import './MultiSelectComponent.css'
import Button from '@mui/material/Button';

export interface MultiSelectOption<T> {
	value: T
	displayName: string
	isButton?: boolean
}

export interface MultiSelectComponentProps<T> {
	modelValue: T
	disabled?: boolean
	setCb: (v: T) => void
	options: MultiSelectOption<T>[]
	vertical?: boolean
}

export function MultiSelectComponent<T>({modelValue, disabled, options, setCb, vertical = false}: MultiSelectComponentProps<T>) {
	return (
		<div className={classnames('MultiSelectComponent', {
			horizontal: !vertical,
			vertical,
		})}>
			{options.map((o, key) => {
				const onClick = () => !disabled && setCb(o.value);
				const selected = modelValue == o.value
				if (!o.isButton) {
					return (
						<FormControlLabel
							key={key}
							control={<Radio color={'primary'} checked={selected}/>}
							label={o.displayName}
							disabled={disabled}
							onClick={onClick}
						/>
					)
				} else {
					return (
						<Button
							key={key}
							disabled={disabled}
							onClick={onClick}
							variant={selected ? 'contained' : 'text'}
							color={selected ? 'primary' : undefined}
						>
							{o.displayName}
						</Button>
					)
				}
			})}
		</div>
	);
}